import { siteConfig } from '@/mocks/home';

export default function CTABanner() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20fantasy%20landscape%20with%20golden%20sunrise%20over%20mountains%2C%20dramatic%20sky%2C%20warm%20crimson%20and%20amber%20clouds%2C%20cinematic%20game%20art%2C%20heroic%20atmosphere%2C%20grand%20scale%2C%20inspirational%20composition&width=1600&height=500&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-900/85 via-primary-900/80 to-primary-900/85"></div>
      </div>

      <div className="relative z-10 mx-auto px-4 md:px-6 max-w-3xl text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好踏上征途了吗？
        </h2>
        <p className="text-base text-foreground-200 mb-8 leading-relaxed">
          五千万玩家的共同选择，经典征途国际手游等你来战！<br />
          立即下载征途国际最新版App，开启你的热血征途之旅！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={siteConfig.androidDownloadUrl}
            className="flex items-center gap-2.5 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-all duration-300 shadow-[0_8px_30px_rgba(200,140,20,0.35)] whitespace-nowrap cursor-pointer"
          >
            <i className="ri-android-line text-xl"></i>
            Android 下载 {siteConfig.version}
          </a>
          <a
            href={siteConfig.iosDownloadUrl}
            className="flex items-center gap-2.5 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-apple-line text-xl"></i>
            iOS 下载 {siteConfig.version}
          </a>
        </div>
      </div>
    </section>
  );
}